import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"text-align":"center","margin-bottom":"12px","color":"var(--secondary-100)"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "shadow-edit" }
const _hoisted_4 = { class: "shadow-edit__workarea" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "shadow-edit__workarea__data" }
const _hoisted_7 = { class: "shadow-edit__workarea__actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';

import ShadowSettings from '@/components/pages/Shadow/ShadowSettings/ShadowSettings.vue';
import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';
import { sizesEn } from '@/data/outpaintSizes/sizesEn';


export default /*@__PURE__*/_defineComponent({
  __name: 'Shadow',
  setup(__props) {

const paddingList = [8, 14];

const { t } = useI18n();
const baseUrl = process.env.VUE_APP_BASE_URL;

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const {
  imageForActions,
  imageResult,
  // sourceShadowImg,
  imagePrev,
  shadowParams,
  shadowParamsCanvasWidth,
  shadowParamsCanvasHeight,
  shadowParamsFormat,
  shadowParamsType,
} = storeToRefs(useServicesStore());

const key = ref<number>(0);
const generationLoading = ref<boolean>(false);
const sizeIndex = ref<number>(0);
const customWidth = ref<number>(0);
const customHeight = ref<number>(0);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const canvasWidth = ref<number>(0);
const canvasHeight = ref<number>(0);
const imgContainerRef = ref<any>();
const isEdit = ref<boolean>(false);

const ratio = computed(() => {
  let result = 0;
  if (imgContainerRef.value) {
    if (
      imgContainerRef.value.clientWidth / imgContainerRef.value.clientheight
      > canvasWidth.value / canvasHeight.value
    ) {
      result = imgContainerRef.value.clientWidth / canvasWidth.value;
    } else {
      result = imgContainerRef.value.clientHeight / canvasHeight.value;
    }
  }
  return result;
});
// const imageSize = computed(() => getBase64Size(imageForActions.value));
const sizesList = computed(() => (sizesEn));
const computedPadding = computed(() => {
  let result;
  if (shadowParams.value.paddingIndex !== -1 && shadowParams.value.paddingIndex !== -2) {
    let customPadding = 0;
    if (shadowParamsCanvasWidth.value / shadowParamsCanvasHeight.value > imageWidth.value / imageHeight.value) {
      customPadding = (shadowParamsCanvasHeight.value / 100) * paddingList[shadowParams.value.paddingIndex];
    } else {
      customPadding = (shadowParamsCanvasWidth.value / 100) * paddingList[shadowParams.value.paddingIndex];
    }
    result = `${customPadding * ratio.value}px`;
  } else if (shadowParams.value.paddingIndex === -1) {
    result = `${shadowParams.value.padding * ratio.value}px`;
  } else if (shadowParams.value.paddingIndex === -2) {
    result = `${shadowParams.value.paddingTop * ratio.value}px ${shadowParams.value.paddingRight * ratio.value}px ${
      shadowParams.value.paddingBottom * ratio.value
    }px ${shadowParams.value.paddingLeft * ratio.value}px`;
  }
  return result;
});

const shadowFileHandler = (): void => {
  generationLoading.value = true;

  let paddingInt = {};
  if (shadowParams.value.paddingIndex === -2) {
    paddingInt = {
      left_pad: shadowParams.value.paddingLeft,
      right_pad: shadowParams.value.paddingRight,
      bottom_pad: shadowParams.value.paddingBottom,
      top_pad: shadowParams.value.paddingTop,
    };
  } else if (shadowParams.value.paddingIndex === -1) {
    paddingInt = {
      left_pad: shadowParams.value.padding,
      right_pad: shadowParams.value.padding,
      bottom_pad: shadowParams.value.padding,
      top_pad: shadowParams.value.padding,
    };
  }

  generateImage({
    action: 'shadow',
    image: removeBase64Prefix(imageForActions.value),
    params: {
      form: shadowParamsFormat.value,
      mode: shadowParamsType.value,
      padding: paddingInt,
      color: shadowParams.value.shadowColor === '' ? null : shadowParams.value.shadowColor,
      align: shadowParams.value.position,
      shadow: shadowParams.value.isShadow,
      size: {
        height: shadowParamsCanvasHeight.value,
        width: shadowParamsCanvasWidth.value,
      },
    },
  })
    .then((res) => {
      imagePrev.value = imageForActions.value;
      imageForActions.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
      imageResult.value = `data:image/png;base64,${res.image}`;
      // sourceShadowImg.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
    })
    .catch((e) => {
      busError.emit(e?.error || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

const setSize = (index: number): void => {
  sizeIndex.value = index;
  if (index === -1) {
    canvasWidth.value = customWidth.value;
    canvasHeight.value = customHeight.value;
  } else {
    canvasWidth.value = sizesList.value[index].width;
    canvasHeight.value = sizesList.value[index].height;
  }
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      customWidth.value = img.width;
      customHeight.value = img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
  setTimeout(() => {
    setSize(0);
  }, 100);
});

watch(imageForActions, () => {
  imageSizeHandler();
  setTimeout(() => {
    setSize(0);
  }, 100);
});

watch(imageResult, () => {
  if (imageResult.value === '' && imagePrev.value !== '') {
    imageForActions.value = imagePrev.value;
  }
});

watch(customHeight, (newVal) => {
  canvasHeight.value = newVal;
});

watch(customWidth, (newVal) => {
  canvasWidth.value = newVal;
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, {
        key: 0,
        "is-remove-bg": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('menu.shadow')), 1),
          _createElementVNode("img", {
            src: `${_unref(baseUrl)}/images/multi-menu/shadow.png`,
            alt: ""
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'service__container--mobile': _unref(isMobile) }, "service__container shadow"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (isEdit.value)
              ? (_openBlock(), _createBlock(ImageFinetune, {
                  key: 0,
                  class: "shadow-background-edit__finetune",
                  src: _unref(imageForActions),
                  onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                  onSave: editHandler,
                  actions: ['reset', 'save']
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(ShadowSettings),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(AiCard, {
                      radius: 16,
                      class: "shadow-edit__workarea__card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "shadow-edit__workarea__container",
                          ref_key: "imgContainerRef",
                          ref: imgContainerRef
                        }, [
                          _createElementVNode("div", {
                            class: "shadow-edit__workarea__container__inner",
                            style: _normalizeStyle({
                  padding: computedPadding.value,
                  width: `${_unref(shadowParamsCanvasWidth) * ratio.value}px`,
                  height: `${_unref(shadowParamsCanvasHeight) * ratio.value}px`,
                  // 'min-height': `${canvasHeight * ratio}px`,
                })
                          }, [
                            _createElementVNode("img", {
                              src: _unref(imageForActions),
                              alt: "",
                              style: _normalizeStyle({ objectPosition: _unref(shadowParams).position })
                            }, null, 12, _hoisted_5),
                            (generationLoading.value)
                              ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
                              : _createCommentVNode("", true)
                          ], 4)
                        ], 512),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => {
                    imageForActions.value = '';
                    imageResult.value = '';
                  })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                              ]),
                              _: 1
                            }),
                            (!_unref(isMobile))
                              ? (_openBlock(), _createBlock(AiButton, {
                                  key: 0,
                                  disabled: generationLoading.value,
                                  theme: "gradient-primary",
                                  class: "shadow-edit__workarea__button",
                                  onClick: shadowFileHandler
                                }, {
                                  default: _withCtx(() => [
                                    (!generationLoading.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('shadow.create-shadow')), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})